import { render, staticRenderFns } from "./footer-index.vue?vue&type=template&id=ab72f3ba&scoped=true&"
var script = {}
import style0 from "./footer-index.vue?vue&type=style&index=0&id=ab72f3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab72f3ba",
  null
  
)

export default component.exports